import { Ppv } from '@kaltura-ott/tvpil-shared';

export function getOptions(rents: Ppv[], resolveRent: Function) {
  return rents?.map((rent, index) => {
    const { duration, price } = resolveRent(rent);
    return { value: String(index), text: price, additionalInfo: duration };
  });
}
